module.exports = __webpack_public_path__ + "static/media/icon-tag-moduleF1.df34401a.png";